var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"marketScout"}},[_c('AppHeader'),_c('v-content',[_c('router-view')],1),_c('AppFooter'),_c('notifications',{attrs:{"position":"bottom right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }